import React from 'react'
import { connect } from 'react-redux' 
import { Route } from 'react-router'
import PropTypes from 'prop-types'
import LoginContainer from '../containers/LoginContainer'

const PrivateRoute = (props) => {
	const { isLoggedIn, component: Component, ...rest } = props
	return (
		<Route
			{...rest}
			render={props =>
				isLoggedIn ? (
					<Component {...props} />
				) : (
					<LoginContainer {...props}/>
				)
			}
		/>
	)
}

PrivateRoute.propTypes = {
	isLoggedIn: PropTypes.bool,
	component: PropTypes.node
}

const mapStateToProps = (state, ownProps) => ({
	isLoggedIn: state.login.isLoggedIn,
	...ownProps
})


export default connect(mapStateToProps)(PrivateRoute)


// WEBPACK FOOTER //
// ./src/routes/PrivateRoute.js